document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('#product-extra-information');
    if (!container) return;

    // 1. Exclusive Toggle: Use "capture" phase to intercept the click
    container.addEventListener('click', function(event) {
        const summary = event.target.closest('summary');
        if (!summary) return;

        const currentDetails = summary.closest('details');
        const allAccordions = container.querySelectorAll('details');

        // If we are about to open a closed one
        if (!currentDetails.hasAttribute('open')) {
            allAccordions.forEach((details) => {
                // Find any other detail that is currently open and close it
                if (details !== currentDetails && details.hasAttribute('open')) {
                    // We click the summary of the OTHER ones to trigger theme animations
                    details.querySelector('summary').click();
                }
            });
        }
    }, true); // The "true" here is key: it intercepts the click early

    // 2. "Read More" link handler
    const readMoreLink = document.querySelector('a[href="#description"]');
    if (readMoreLink) {
        readMoreLink.addEventListener('click', function(e) {
            e.preventDefault();
            const descAccordion = document.querySelector('accordion-disclosure[data-accordion-item="description"]');
            const descSummary = descAccordion?.querySelector('summary');
            const descDetails = descAccordion?.querySelector('details');

            if (descAccordion && descSummary) {
                descAccordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
                if (!descDetails.hasAttribute('open')) {
                    descSummary.click();
                }
            }
        });
    }
});
// Country selectors share one country list (snippets/localization-selector.liquid, type "country-options").
// It is copied into a selector's popover right before that popover opens for the first time.
document.addEventListener('dialog:before-show', function(event) {
    const placeholder = event.target.querySelector?.('[data-country-options]');
    const template = document.getElementById('country-options-template');
    if (!placeholder || !template) return;

    const options = template.content.cloneNode(true);
    if (placeholder.hasAttribute('data-hide-flags')) {
        options.querySelectorAll('.country-flag').forEach((flag) => flag.remove());
    }
    placeholder.replaceWith(options);
}, true); // Capture phase, as "dialog:before-show" does not bubble

// Shopify appends tracking parameters to product links coming from recommendations
// ("Dr. Anita Recommends", "Pairs well with") and from search results. They are read
// when the page is requested, so drop them from the address bar once the page has loaded.
window.addEventListener('load', function() {
    const trackingParams = ['pr_prod_strat', 'pr_rec_id', 'pr_rec_pid', 'pr_ref_pid', 'pr_seq', '_pos', '_sid', '_ss', '_psq', '_fid', '_v'];
    const url = new URL(window.location.href);
    const present = trackingParams.filter((param) => url.searchParams.has(param));
    if (present.length === 0) return;

    present.forEach((param) => url.searchParams.delete(param));
    window.history.replaceState(window.history.state, '', url.toString());
});
